import { getRealtimeUpdaterClient } from '@trello/realtime-updater-client';

import { Subscriber } from 'app/src/Subscriber';

// eslint-disable-next-line @trello/no-module-logic
const realtimeUpdaterClient = getRealtimeUpdaterClient();
// eslint-disable-next-line @trello/no-module-logic
export const subscriber = new Subscriber(realtimeUpdaterClient);
